"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceOfferSchema = exports.MarketplaceOfferStatusSchema = exports.APosMarketplaceOfferSchema = exports.APosMarketplaceOfferStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosMarketplaceOfferStatusSchema = zod_1.z.enum(['pending', 'approved', 'rejected', 'suspended']);
exports.APosMarketplaceOfferSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string().min(1),
    mp_productId: zod_1.z.string().min(1),
    sellerTenantId: id_schema_1.TenantIdSchema,
    variantId: zod_1.z.string().min(1),
    locationIds: zod_1.z.array(zod_1.z.string()).default([]),
    price: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().default('USD'),
    inStock: zod_1.z.boolean().default(true),
    lowStockThreshold: zod_1.z.number().int().nonnegative().optional(),
    localDeliveryAvailable: zod_1.z.boolean().default(false),
    shippingAvailable: zod_1.z.boolean().default(false),
    pickupAvailable: zod_1.z.boolean().default(false),
    sellerAvgReview: zod_1.z.number().min(0).max(5).optional(),
    productAvgReview: zod_1.z.number().min(0).max(5).optional(),
    offerCreatedAt: zod_1.z.number().optional(),
    status: exports.APosMarketplaceOfferStatusSchema.default('pending'),
    approvedAt: zod_1.z.number().optional(),
    approvedBy: zod_1.z.string().optional().describe('OWNER user id'),
    rejectionReason: zod_1.z.string().optional(),
    lastSyncedAt: zod_1.z.number().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
// ---------------------------------------------------------------------------
// Phase I — offer schema (string timestamps; review/fulfillment booleans).
// Additive: distinct export names; APosMarketplaceOffer* untouched.
// ---------------------------------------------------------------------------
exports.MarketplaceOfferStatusSchema = zod_1.z.enum([
    'pending',
    'approved',
    'rejected',
    'suspended',
]);
/**
 * One seller's listing inside one marketplace.
 * PK: `${marketplaceId}#${mp_productId}`  SK: `${sellerTenantId}#${variantId}`
 */
exports.MarketplaceOfferSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string(),
    mp_productId: zod_1.z.string(),
    sellerTenantId: zod_1.z.string(),
    variantId: zod_1.z.string(),
    locationIds: zod_1.z.array(zod_1.z.string()),
    // pulled live from VariantLocation.online.price
    price: zod_1.z.number(),
    currency: zod_1.z.string(),
    inStock: zod_1.z.boolean(),
    lowStockThreshold: zod_1.z.boolean(),
    // fulfillment capability (from LocationFulfillmentConfig)
    localDeliveryAvailable: zod_1.z.boolean(),
    shippingAvailable: zod_1.z.boolean(),
    pickupAvailable: zod_1.z.boolean(),
    // ranking signals + review aggregates (O15)
    sellerAvgReview: zod_1.z.number(),
    productAvgReview: zod_1.z.number(),
    productReviewCount: zod_1.z.number(),
    offerCreatedAt: zod_1.z.string(),
    // moderation (owner-driven)
    status: exports.MarketplaceOfferStatusSchema,
    approvedAt: zod_1.z.string().optional(),
    approvedBy: zod_1.z.string().optional(), // = OWNER user id
    rejectionReason: zod_1.z.string().optional(),
    lastSyncedAt: zod_1.z.string(),
});
//# sourceMappingURL=marketplace-offer.schema.js.map